<!-- eslint-disable vue/no-mutating-props -->
<script>
import CreateGroup from './CreateGroup.vue';
import JoinGroup from './JoinGroup.vue';
export default {
  components: {
    CreateGroup,
    JoinGroup,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inboxesList: {
      type: Array,
      default: () => [],
    },
    selectedInbox: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isLoading: false,
      modeSelection: '',
      activeInbox: null,
    };
  },
  watch: {
    inboxesList() {
      this.updateSelectedInbox();
    },
    selectedInbox() {
      this.updateSelectedInbox();
    },
  },
  mounted() {
    this.updateSelectedInbox();
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    },
    updateSelectedInbox() {
      this.activeInbox = this.inboxesList.find(
        // eslint-disable-next-line eqeqeq
        ({ id }) => id == this.selectedInbox
      );
      this.modeSelection =
        this.activeInbox?.player === 'codechat' ? 'createGroup' : 'joinGroup';
    },
  },
};
</script>

<template>
  <woot-modal
    :show="show"
    size="medium"
    :on-close="onClose"
    @update:show="val => (show = val)"
  >
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('CHAT_LIST.ENTER_OR_CREATE_GROUP')"
      />
      <div class="main-container">
        <div class="mode-selection-container">
          <label v-if="activeInbox && activeInbox.player !== 'codechat'">
            <input
              v-model="modeSelection"
              class="checkbox"
              name="join-group"
              type="radio"
              value="joinGroup"
              :disabled="isLoading"
            />
            {{ $t('CHAT_LIST.JOIN_GROUP_WITH_INVITE_LINK') }}
          </label>
          <label>
            <input
              v-model="modeSelection"
              class="checkbox"
              name="join-group"
              type="radio"
              value="createGroup"
              :disabled="isLoading"
            />
            {{ $t('CHAT_LIST.CREATE_GROUP') }}
          </label>
        </div>

        <CreateGroup
          v-if="modeSelection == 'createGroup'"
          class="px-20 pb-4 w-full"
          :is-loading="isLoading"
          :inbox="activeInbox"
          @on-submit="isLoading = true"
          @success="
            isLoading = false;
            onClose();
          "
        />
        <JoinGroup
          v-if="modeSelection == 'joinGroup'"
          :is-loading="isLoading"
          :inbox="activeInbox"
          @on-submit="isLoading = true"
          @success="
            isLoading = false;
            onClose();
          "
        />
      </div>
    </div>
  </woot-modal>
</template>

<style lang="scss" scoped>
.main-container,
.mode-selection-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.mode-selection-container {
  align-items: flex-start;
}
</style>
